export default "__VITE_ASSET__CtaJPMKZ__"